<sl-page-header header="Organizations" i18n-header>
    <div slot="actions" style="box-sizing: border-box">
        <sl-button (click)="addNew($event)" type="primary" i18n>New Organization</sl-button>
    </div>
</sl-page-header>
<sl-layout>

    <sl-well class="my-6" *ngIf="invitations.length > 0">
        <sl-list  lines="full" >
            <sl-list-item *ngFor="let invitation of invitations">
                <sl-label class="m-3" i18n>You have been invited to be part of {{organizationName(invitation)}}</sl-label>
                <sl-button slot="suffix" size="small" i18n (click)="acceptInvitation(invitation)">Accept invitation</sl-button>
            </sl-list-item>
        </sl-list>
    </sl-well>

    <sl-empty *ngIf="organizations.length == 0 && !loading" header="No organizations" class="mt-6" i18n-header>
        <span i18n>Get started by creating an organization</span>
        <sl-button (click)="addNew($event)" type="primary" slot="actions" i18n>New Organization</sl-button>
    </sl-empty>

    <ng-container *ngIf="organizations.length > 0 || loading">
        <sl-table class="mt-8">
            <sl-column i18n>Name</sl-column>
            <sl-column i18n>Address</sl-column>
            <sl-column i18n>Role</sl-column>
            <sl-row *ngIf="loading">
                <sl-cell><sl-skeleton effect="sheen"></sl-skeleton></sl-cell>
                <sl-cell><sl-skeleton effect="sheen"></sl-skeleton></sl-cell>
                <sl-cell><sl-skeleton effect="sheen"></sl-skeleton></sl-cell>
            </sl-row>
            <sl-row (click)="onClick(organization)" *ngFor="let organization of organizations">
                <sl-cell>
                    <sl-label weight="semibold">
                        {{organization?.name}}
                        <sl-badge class="ml-3" *ngIf="organization.terminated" type="info" i18n>Inactive</sl-badge>
                        <sl-badge class="ml-3" *ngIf="organization.trial" type="warning" i18n>Trial period</sl-badge>
                    </sl-label>

                </sl-cell>
                <sl-cell><sl-label color="medium">{{organization | address}}</sl-label></sl-cell>
                <sl-cell><sl-label color="medium">{{getDisplayRole(organization)}}</sl-label></sl-cell>
            </sl-row>
        </sl-table>
        <div class="mt-3 text-right">
            <sl-pagination [totalPages]="totalPages" (pageChange)="page = $any($event).detail"></sl-pagination>
        </div>
    </ng-container>
</sl-layout>